import { render } from "./Walkthroughs.vue?vue&type=template&id=286ec368&scoped=true"
import script from "./Walkthroughs.vue?vue&type=script&lang=js"
export * from "./Walkthroughs.vue?vue&type=script&lang=js"

import "./Walkthroughs.vue?vue&type=style&index=0&id=286ec368&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-286ec368"]])

export default __exports__